import {
  useEffect, useMemo,
} from 'react';
import { type LatLng } from '~/_shared/types/latLng';
import { createUuid } from '~/_shared/utils/createUuid';
import {
  MapObjectOutlineSize, type MapObjectZIndex,
} from '../../mapObject.types';
import type { MapObjectManager } from '../../private/mapObjectManager';

const SNAP_CURSOR_COLOR = [255, 255, 255, 0.2] as const;

export const useSnapCursorDot = ({
  manager,
  snappedPosition,
  zIndex,
}: {
  manager: MapObjectManager;
  snappedPosition: LatLng | undefined;
  zIndex: MapObjectZIndex;
}) => {
  const dotId = useMemo(() => createUuid(), []);

  useEffect(() => {
    if (!snappedPosition) {
      manager.removeOutlineMarker(dotId);
      return;
    }

    manager.upsertOutlineMarker({ id: dotId, lat: snappedPosition.lat, lng: snappedPosition.lng }, {
      color: SNAP_CURSOR_COLOR,
      size: MapObjectOutlineSize.Default,
      zIndex: zIndex.outlineDot,
    });
  }, [manager, zIndex.outlineDot, dotId, snappedPosition]);

  useEffect(() => () => {
    manager.removeOutlineMarker(dotId);
  }, [manager, dotId]);
};
